import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles, List, ListItem, ListItemText, Button, Dialog, Card, CardContent } from '@material-ui/core';
import Strapi from '../../services/strapi';
import { useParams } from 'react-router-dom';
import { RevisionInterface } from '../../interfaces/article';
import { useAuthentication, Role } from '../../contexts/Authentication';
import { useNotification } from '../../contexts/Notification';
import settings from '../../settings';
import Confirm from '../../atoms/Confirm';

interface RevisionRemoveProps {
	article_type: string,
	article_id: number,
	revision_id: number,
	update: () => void,
}

const RevisionRemove = (props: RevisionRemoveProps) => {
	const notification = useNotification();

	return <Confirm
		message="Confirmer la supression"
		action={() => {
			return Strapi.delete(`${props.article_type}s/${props.article_id}/${props.revision_id}`).then((r) => {
				notification.notify("Removed");
				props.update();
			});
		}}
		trigger="Supprimer"
	/>
}

interface RevisionChangeProps {
	article_type: string,
	article_id: number,
	revision_id: number,
	revision_date: string,
	update: () => void,
}

const RevisionChange = (props: RevisionChangeProps) => {
	const notification = useNotification();
	
	return <Confirm
		message={`Est ce que vous êtes sûr de rétablir la version du ${props.revision_date}`}
		trigger={"Rétablir"}
		action={() => {
			notification.notify("changing revision...", "info");
			return changeRevision(props.article_type, props.article_id, props.revision_id)
				.then(r => {
					notification.notify("revision changed");		
					props.update();
				}).catch(e => {
					notification.notify("fail to change revision", "error");
				});
	}}
/>
}

const changeRevision = (article_type: string, article_id: number, revision_id: number) => {
	return Strapi.put(`${article_type}s/${article_id}/revision`, {}, {
		revision_id
	})
}

const useStyles = makeStyles({
	container: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column'
	}
});

interface RevisionItemProps {
	articleId: number,
	revisionId: number,
	slug: string,
	revision: any,
	collection: string,
	update: () => void
}

const canChangeRevision = (roles: Role[]) => {
	return [Role.Administrateur, Role.Editorial1, Role.Editorial2, Role.Redacteur, Role.RedacteurChef, Role.RedacteurJunior].some(r => roles.includes(r));
}

const RevisionMessage = (props: {message: string}) => {
	const [open, setOpen] = useState<boolean>(false);

	return <>
		<Button onClick={() => {
			setOpen(true);
		}}>Voir le message</Button>
		<Dialog open={open} onClose={() => {
			setOpen(false)
		}}>
			<Card>
				<CardContent>
					<p>{props.message}</p>
				</CardContent>
			</Card>
		</Dialog>
	</>
}

const RevisionItem = (props: RevisionItemProps) => {
	const [expanded, setExpanded] = useState<boolean>(false);
	const dateFormater = new Intl.DateTimeFormat("fr", {
		year: "numeric",
		month: "long",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	});
	const auth = useAuthentication();

	return <ListItem onClick={() => {
		setExpanded(!expanded);
	}}>
		<ListItemText>{dateFormater.format(new Date(props.revision.date))}</ListItemText>
		<ListItemText>{props.revision.author?.slug}</ListItemText>
		{canChangeRevision(auth.role) && <ListItemText>
			{(props.revisionId === props.revision.id) ? "version en cours" : <>
				<RevisionChange
					article_id={props.articleId}
					revision_id={props.revision.id}
					article_type={props.collection}
					update={props.update}
					revision_date={dateFormater.format(new Date(props.revision.date))}
				/>
				{auth.role.includes(Role.Administrateur) &&
					<RevisionRemove
						article_id={props.articleId}
						revision_id={props.revision.id}
						article_type={props.collection}
						update={props.update}
					/>}
			</>}
		</ListItemText>}
		<ListItemText>
			<Button href={`${settings.frontUrl}article/${props.collection}/${props.slug}?revision=${props.revision.id}`}>Preview</Button>
		</ListItemText>
		<ListItemText>
			<RevisionMessage message={props.revision.message}/>
			{/* {props.revision.message} */}
		</ListItemText>
	</ListItem>
}

interface RevisionProps {
	collection: string
}

const Revision = (props: RevisionProps) => {
	const { slug } = useParams<{ slug: string }>();
	const [article, setArticle] = useState<any>({});
	const classes = useStyles();

	const update = () => {
		return Strapi.get(`${props.collection}s/${slug}`).then((r) => {
			r.data.revisions.sort((a: RevisionInterface, b: RevisionInterface) => (a.date > b.date ? -1 : 1));
			setArticle(r);
		});
	}
	const revisions = useMemo(() => ((article && article.data && article.data.revisions) ?
		article.data.revisions.map((e: any, i: number) => {
			return <RevisionItem update={update} slug={slug} collection={props.collection} revisionId={article.data.current_revision} key={i} articleId={article.data.id} revision={e} />
		}) : []), [article]);

	useEffect(() => {
		update();
	}, []);

	return (
		<div>
			<List className={classes.container}>
				{revisions}
			</List>
		</div>
	);
}

export default Revision;